import { useState } from "react";
import { Input } from "@/components/ui/input";

export const EntriesTable = ({ entries }) => {
  const [q, setQ] = useState("");
  const rows = entries.filter((e) =>
    [e.english_question, e.hindi_question, e.song, e.film, e.category].join(" ").toLowerCase().includes(q.toLowerCase())
  );
  return (
    <section>
      <Input placeholder="Search questions or songs..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="entries-search-input" className="mb-4 max-w-sm border-slate-600 bg-[#161926] text-white" />
      <div className="overflow-x-auto rounded-2xl border border-slate-700">
        <table className="w-full text-left text-sm" data-testid="entries-table">
          <thead className="bg-[#1e2235] text-xs uppercase tracking-wider text-slate-400">
            <tr><th className="p-3">Question</th><th className="p-3">Hindi</th><th className="p-3">Song</th><th className="p-3">Category</th><th className="p-3">Video</th></tr>
          </thead>
          <tbody>
            {rows.map((e) => (
              <tr key={e.id} className="border-t border-slate-800 hover:bg-white/5" data-testid={`entry-row-${e.id}`}>
                <td className="p-3 text-white">{e.english_question}</td>
                <td className="font-hindi p-3 text-[var(--hindi)]">{e.hindi_question || <span className="text-slate-600">—</span>}</td>
                <td className="p-3 text-slate-300">{e.song}{e.film ? ` (${e.film})` : ""}</td>
                <td className="p-3 text-slate-400">{e.category}</td>
                <td className="p-3"><a href={e.youtube_url} target="_blank" rel="noreferrer" className="text-cyan-400 hover:underline">Open</a>
                  {e.embeddable === false && <span data-testid={`entry-blocked-${e.id}`} className="ml-2 rounded bg-rose-500/20 px-2 py-0.5 text-xs text-rose-300">Embed blocked</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
